// https://mobiledev.aigupiao8.com/H5ReactUserCenter/getUserInfo
import * as Api from '@/utils/request'

export default {

    /**
     * 获取首页分享参数
     * @returns {Promise.<*>}
     */

    //获取首页指数板块数据
    async getShareInfo(opt) {
        return await Api.get({
            url: '/H5ReactUserCenter/getShareInfo',
            params: {
                ...opt
            }
        })
    },

}